export default {"src":"/_next/static/media/agrotourism.4b039c23.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};